import styled from 'styled-components'

export const StyledButton = styled.div<{backgroundColor: string}>`
  background-color: ${({backgroundColor}) => backgroundColor};
  display: flex;
  text-transform: none;
  height: 44;
  margin: 8px;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 20px;
  color: white;
  cursor: pointer;
  border-radius: 5px;

  &:hover {
    opacity: 0.8;
    background-color: ${({backgroundColor}) => backgroundColor};
  }
`